<template>
  <div class="ticket-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        size="small"
        class="query-middle"
      >
        <el-form-item label="行程单编号：">
          <el-input v-model="query.Code"></el-input>
        </el-form-item>
        <el-form-item label="行程时间：" style="margin-left:20px;">
          <el-date-picker
            v-model="query.StartTime"
            type="date"
            style="width: 200px"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="—">
          <el-date-picker
            v-model="query.EndTime"
            type="date"
            style="width: 200px"
           format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left:20px;">
          <el-button type="primary" icon="el-icon-search" @click="getTickets"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            icon="el-icon-circle-close"
            @click="resetForm('queryForm')"
            >清除</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i> 行程单列表 </span>
          <el-button-group>
            <router-link to="/ticket-input">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-circle-plus-outline"
                >新增</el-button
              >
            </router-link>
          </el-button-group>
        </div>
        <div class="left-table">
          <el-table :data="tableData" height="753px" border style="width: 100%" v-loading="loadintTable">
            <el-table-column
              type="selection"
              min-width="10"
              align="center"
            ></el-table-column>
            <el-table-column
              label="行程单编号"
              prop="Code"
              min-width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              label="线路名称"
              prop="Name"
              min-width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="开始时间"
              prop="StartTime"
              min-width="140"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.StartTime | dateFormatTemp }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="结束时间"
              prop="EndTime"
              min-width="140"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.EndTime | dateFormatTemp }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="人数"
              prop="TouristCount"
              min-width="60"
              align="center"
            ></el-table-column>
            <el-table-column
              label="状态"
              prop="Status"
              min-width="80"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Status | keyToVal(statusType)"
                  effect="dark"
                  size="small"
                  >{{ scope.row.Status | keyToVal(ticketStatus) }}</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              min-width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-button
                    size="mini"
                    type="primary"
                    v-on:click="getDetail(scope.row)"
                    >查看</el-button
                  >
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="pagination.total"
            :page-size="pagination.PageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="pagination.PageIndex"
            v-on:size-change="handlePageSize"
            v-on:current-change="handlePageIndex"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span> <i class="el-icon-document"></i> 查看 </span>
          <el-button-group>
            <el-button
              type="warning"
              v-show="flag === 1 &&  IsTrip===0"
              size="mini"
              @click="edit"
              >编辑</el-button
            >
            <el-button
              type="success"
              v-show="flag === 2 &&  IsTrip===0"
              size="mini"
              @click="submitForm('updateForm')"
              >保存</el-button
            >
          </el-button-group>
        </div>
        <div class="right-table">
          <table class="input-form" v-show="flag === 1" v-loading="loadingLook">
            <thead>
              <th colspan="7">电子行程单（查看）</th>
            </thead>
            <tbody>
              <tr style="height: 41px">
                <td>行程编号</td>
                <td colspan="2">{{ detail.Code }}</td>
                <td>行程描述</td>
                <td colspan="3"><el-input v-model="detail.Remarks" readonly ></el-input></td>
                <!-- <td colspan="3">{{ detail.Remarks }}</td> -->
              </tr>
              <tr style="height: 41px">
                <td>行程名称</td>
                <td>{{ detail.Name }}</td>
                <td>组团旅行社</td>
                <td>{{ detail.CompanyName }}</td>
                <td>行程时间</td>
                <td colspan="2">
                  {{ detail.StartTime + " 至 " + detail.EndTime }}
                </td>
              </tr>
              <tr style="height: 41px">
                <td>行程人数</td>
                <td>{{ detail.TouristCount }}</td>
                <td>行程起点</td>
                <td><el-input v-model="detail.StartPoint" readonly></el-input></td>
                <!-- <td>{{ detail.StartPoint }}</td> -->
                <td>行程终点</td>
                <td colspan="2"><el-input v-model="detail.EndPoint" readonly ></el-input></td>
                <!-- <td colspan="2">{{ detail.EndPoint }}</td> -->
              </tr>
              <tr>
                <td colspan="7" class="emphasis">行程安排</td>
              </tr>
              <tr style="height: 45px">
                <td colspan="7"></td>
              </tr>
              <div class="subtable-tab">
                <div
                  v-for="(item, index) in table"
                  :key="index"
                  class="mouse-pointer tab-item"
                  :class="{ 'sub-selected': currentSubId === item.id }"
                  @click="switchSubtable(item.id)"
                >
                  <div>第{{ item.id + 1 }}天</div>
                </div>
              </div>
              <tr>
                <td colspan="2">行程项目</td>
                <td colspan="2">行程时间(分钟)</td>
                <td colspan="2">行程类型</td>
                <td>是否自费</td>
              </tr>
              <tr
                v-for="item in table[currentSubId].arrangement"
                :key="item.PointId"
              >
                <td colspan="2">{{ item.Projects }}</td>
                <td colspan="2">{{ item.TimeSpan }}</td>
                <!-- <td colspan="2">{{ item.Time[0] + " 至 " + item.Time[1] }}</td> -->
                <td colspan="2">{{ item.PointType }}</td>
                <td>{{ item.IsSelf == false ? "否" : "是" }}</td>
              </tr>

              <tr v-for="(item, index) in model.guides" :key="index + 999">
                <td>导游</td>
                <td>{{ item.Name }}</td>
                <td>导游证</td>
                <td>{{ item.IDNumber }}</td>
                <td colspan="2">联系方式</td>
                <td>{{ item.Tel }}</td>
              </tr>

              <!-- 自备车 -->
              <tr style="height:45px;">
                <td>是否是自备车</td>
                <td colspan="6">
                  <el-radio v-model="detail.IsSelf" label="0" border disabled>否</el-radio>
                  <el-radio v-model="detail.IsSelf" label="1" border disabled>是</el-radio>
                </td>
                <!-- <td colspan="4" style="color:red;">如果是自备车,请选择'是'</td> -->
              </tr>
              <tr v-show="detail.IsSelf==='0'" v-for="(item, index) in model.drivers" :key="index + 888">
                <td>司机</td>
                <td>{{ item.Name }}</td>
                <td>车牌号</td>
                <td>{{ model.buses[index].PlateNumber }}</td>
                <td colspan="2">联系方式</td>
                <td>{{ item.Tel }}</td>
              </tr>
              <tr v-show="detail.IsSelf==='1'" v-for="(item,index) in model.selfBus" :key="index+555">
                <td>司机</td>
                <td>{{item.selfDriverName}}</td>
                <td>车牌号</td>
                <td>{{item.selfPlateNumber}}</td>
                <td colspan="2">联系方式</td>
                <td>{{item.selfDriverTel}}</td>
              </tr>
              <tr>
                <td :rowspan="visitors.length + 2">游客信息</td>
                <td>游客姓名</td>
                <td>人数（人）</td>
                <td style="min-width: 100px">手机号</td>
                <td colspan="2">身份证</td>
                <td>电子合同</td>
              </tr>
              <tr v-for="(item, index) in visitors" :key="index + 222">
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ visitor.Name }}
                  </p>
                </td>
                <td>
                  <p>{{ item.TotoalCount }}</p>
                </td>
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ (visitor.Tel=="" || visitor.Tel==null )?"无":visitor.Tel }}
                  </p>
                </td>
                <td colspan="2">
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ visitor.IDNumber }}
                  </p>
                </td>
                <td>
                  <i
                    class="el-icon-s-order mouse-pointer"
                    @click="openContract(item.Id)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="input-form" v-show="flag === 2">
            <thead>
              <th colspan="7">电子行程单（修改）</th>
            </thead>
            <tbody>
              <tr style="height: 41px">
                <td style="min-width: 80px">行程编号</td>
                <td colspan="2">{{ detail.Code }}</td>
                <td>行程描述</td>
                <td colspan="3">
                  <el-input v-model="detail.Remarks"></el-input>
                </td>
              </tr>
              <tr style="height: 41px">
                <td>行程名称</td>
                <td>{{ detail.Name }}</td>
                <td style="min-width: 120px">组团旅行社</td>
                <td>{{ detail.CompanyName }}</td>
                <td colspan="2">行程时间</td>
                <td colspan="2">
                  {{ detail.StartTime + " 至 " + detail.EndTime }}
                </td>
              </tr>
              <tr style="height: 41px">
                <td>行程人数</td>
                <td>{{ detail.TouristCount }}</td>
                <td>行程起点</td>
                <td>
                    <el-input
                      v-model="detail.StartPoint"
                      placeholder="请输入行程起点"
                    ></el-input>
                </td>
                <td style="min-width: 80px">行程终点</td>
                <td colspan="2">
                    <el-input
                      v-model="detail.EndPoint"
                      placeholder="请输入行程终点"
                    ></el-input>
                </td>
              </tr>
              <tr>
                <td colspan="7" class="emphasis">行程安排</td>
              </tr>
              <tr style="height: 45px">
                <td colspan="7"></td>
              </tr>
              <div class="subtable-tab">
                <div
                  v-for="(item, index) in table"
                  :key="index"
                  class="mouse-pointer tab-item"
                  :class="{ 'sub-selected': currentSubId === item.id }"
                  @click="switchSubtable(item.id)"
                >
                  <div>第{{ item.id + 1 }}天</div>
                </div>
              </div>
              <tr>
                <td colspan="2">行程项目</td>
                <td colspan="2">行程时间(分钟)</td>
                <td colspan="2">行程类型</td>
                <td>是否自费</td>
              </tr>
              <tr
                v-for="item in table[currentSubId].arrangement"
                :key="item.PointId"
              >
                <td colspan="2">{{ item.Projects }}</td>
                <!-- <td colspan="2">
                  {{ item.Time[0] + " 至 " + item.Time[1] }}
                </td> -->
                  <td colspan="2">
                  {{ item.TimeSpan }}
                </td>
                <td colspan="2">{{ item.PointType }}</td>
                <td>{{ item.IsSelf == false ? "否" : "是" }}</td>
              </tr>
              <tr v-if="detail.RemarkTrip&&detail.RemarkTrip!=''&&detail.RemarkTrip!=undefined&&detail.RemarkTrip.length > 0">
                <td colspan="2">备注行程</td>
                <td colspan="5">{{detail.RemarkTrip}}(分钟)</td>
              </tr>
              <tr v-for="(item, index) in model.guides" :key="index + 1400">
                <td>导游</td>
                <td>
                  <el-select v-model="item.Id" placeholder="请选择导游" filterable>
                    <el-option
                      v-for="guide in GuidesOpitons"
                      :key="guide.Id"
                      :label="guide.Name"
                      :value="guide.Id"
                    ></el-option>
                  </el-select>
                </td>
                <td>导游证</td>
                <td>{{ item.Id | getGuideCode(listGuides) }}</td>
                <td>联系方式</td>
                <td>{{ item.Id | getGuideTel(listGuides) }}</td>
                <td class="addItem">
                  <el-button
                    :icon="index == 0 ? 'el-icon-plus' : 'el-icon-minus'"
                    @click="handleMultiple('guide', index)"
                  ></el-button>
                </td>
              </tr>

              <!-- 自备车 -->
              <tr style="height:45px;">
                <td>是否是自备车</td>
                <td colspan="2">
                  <el-radio v-model="detail.IsSelf" label="0" border @change="changeSelfBus" >否</el-radio>
                  <el-radio v-model="detail.IsSelf" label="1" border @change="changeSelfBus" >是</el-radio>
                </td>
                <td colspan="4" style="color:red;">如果是自备车,请选择'是'</td>
              </tr>
              <tr v-show="detail.IsSelf==='0'" v-for="(item, index) in model.drivers" :key="index + 1200">
                <td>司机</td>
                <td>
                  <el-select
                    v-model="item.Id"
                    filterable
                    placeholder="请选择司机"
                  >
                    <el-option
                      v-for="driver in DriversOptions"
                      :key="driver.Tel"
                      :label="driver.Name"
                      :value="driver.Id"
                    ></el-option>
                  </el-select>
                </td>
                <td>车牌号</td>
                <td>
                  <el-select
                    v-model="model.buses[index].Id"
                    filterable
                    placeholder="请选择"
                    :filter-method="dataFilter"
                  >
                    <el-option
                      v-for="bus in listBuses"
                      :key="bus.Id"
                      :label="bus.PlateNumber"
                      :value="bus.Id"
                    ></el-option>
                  </el-select>
                </td>
                <td>联系方式</td>
                <td style="min-width: 140px">
                  {{ item.Id | getDriverTel(listDrivers) }}
                </td>
                <td class="addItem">
                  <el-button
                    :icon="index == 0 ? 'el-icon-plus' : 'el-icon-minus'"
                    @click="handleMultiple('driver', index)"
                  ></el-button>
                </td>
              </tr>
              <tr v-show="detail.IsSelf==='1'" v-for="(item,index) in model.selfBus" :key="index+555">
                 <td>司机</td>
                  <td>
                    <el-input placeholder="请输入司机姓名" v-model="item.selfDriverName"></el-input>
                  </td>
                  <td>车牌号</td>
                  <td>
                    <el-input placeholder="请输入车牌号" v-model="item.selfPlateNumber"></el-input>
                  </td>
                  <td>联系方式</td>
                  <td>
                    <el-input placeholder="请输入司机联系方式" v-model="item.selfDriverTel"></el-input>
                  </td>
                  <td class="addItem">
                    <el-button
                      :icon="index == 0 ? 'el-icon-plus' : 'el-icon-minus'"
                      @click="handleSelfBus(index)"
                    ></el-button>
                  </td>
              </tr>

              <tr>
                <td :rowspan="visitors.length + 2">游客信息</td>
                <td>游客姓名</td>
                <td>人数（人）</td>
                <td style="min-width: 100px">手机号</td>
                <td colspan="2">身份证</td>
                <td>电子合同</td>
              </tr>
              <tr v-for="(item, index) in visitors" :key="index + 222">
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ visitor.Name }}
                  </p>
                </td>
                <td>
                  <p>{{ item.TotoalCount }}</p>
                </td>
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ (visitor.Tel=="" || visitor.Tel==null )?"无":visitor.Tel }}
                  </p>
                </td>
                <td colspan="2">
                  <p
                    v-for="visitor in item.AllTourist"
                    :key="visitor.Id"
                    style="line-height: 30px"
                  >
                    {{ visitor.IDNumber }}
                  </p>
                </td>
                <td>
                  <i
                    class="el-icon-s-order mouse-pointer"
                    @click="openContract(item.Id)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>

          <el-row type="flex" justify="start" style="margin-top: 30px" v-show="flag===1 || flag===2" >
            <el-button type="success" @click="AddOrderLater">继续添加订单</el-button>
          </el-row>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="contractDialog"  >
      <contract-detail
        :orderId="orderId"
        v-if="contractDialog"
      ></contract-detail>

      <div class="btn">
        <el-button @click="contractDialog = false"
          ><a style="color: #000">取 消</a></el-button
        >
        <el-button v-if="contractInfo.ContactAttachment"
          ><a
            :href="
              '/api/co/Order/DownLoadOneDayContact?orderId=' +
              contractInfo.orderId +
              '&sessionId=' +
              sessionId
            "
            style="color: #000"
            >下载合同</a
          ></el-button
        >
      </div>

    </el-dialog>

    <!-- 选择订单弹框 -->
    <el-dialog :visible.sync="orderDialog" title="选择订单" width="70%" :close-on-click-modal="false">
      <div style="overflow: auto; padding: 30px 0">
        <table class="input-form" >
          <tbody>
            <tr>
              <td>游客姓名</td>
              <td>人数（人）</td>
              <td style="min-width: 100px">手机号</td>
              <td colspan="2">游客证件</td>
              <td>是否勾选</td>
            </tr>
            <tr v-for="item in ordersDetail" :key="item.Id">
              <td>
                <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                  {{ visitor.Name }}
                </p>
              </td>
              <td>
                <p>{{ item.TotoalCount }}</p>
              </td>
              <td>
                <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                  {{ (visitor.Tel=="" || visitor.Tel==null)?"无":visitor.Tel }}
                </p>
              </td>
              <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                  {{ visitor.CertificatesType }}
                </p>
              </td>
              <td>
                <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                  {{ visitor.IDNumber }}
                </p>
              </td>
              <td>
                <el-checkbox v-model="item.isSelected">是</el-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderDialog = false">取 消</el-button>
        <el-button type="primary" @click="sureAddOrder" >确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>

import { getToken, getCookie } from "@/common/auth";

import { keyToVal, dateFormat,dateFormatTemp } from "@/filters/filters";
import ContractDetail from "@/components/Contract.vue";
import { mapState } from "vuex";
import Trip from "@/api/trip";
import Guide from "@/api/guide";
import Driver from "@/api/driver";
import Bus from "@/api/bus";
import Order from "@/api/order";
export default {
  name: "TicketManage",
  data() {
    return {
      orderDialog: false,
      ordersDetail: [], //订单详情
      orderSelected: [], //已选择订单
      saveLineId:"",
      saveStartTime:"",
      saveEndTime:"",


      IsTrip:0, //0 行程还未开始   1 已在行程中
      contractInfo: {},
      sessionId: "",

      query: {
        Code: "",
        StartTime: "",
        EndTime: "",
        PageSize: 10,
        PageIndex: 1,
      },
      flag: 0,
      contractDialog: false,
      orderId: "",
      detail: {
      },
      visitors: [
        {
          Id: "",
          Name: "",
          TotoalCount: "",
          Tel: "",
          IDNumber: "",
          OrderId: "",
        },
      ],
      currentSubId: 0,
      table: [
        {
          id: 0,
          arrangement: [],
        },
      ],
      model: {
        guides: [],
        drivers: [],
        buses: [],
        selfBus:[],
      },
      tableData: [
        // {
        //   Id: "",
        //   Name: "",
        //   Code: "",
        //   StartTime: "",
        //   EndTime: "",
        //   GuideName: "",
        //   PlateNumber: "",
        //   Status: 0,
        //   TouristCount: 0,
        // },
      ],
      listGuides: [],
      listDrivers: [],
      listBuses: [],

      GuidesOpitons: [],
      DriversOptions: [],

      pagination: {
        total: 0,
        PageSize: 10,
        PageIndex: 1,
      },

      loadintTable:false,
      loadingLook:false,
    };
  },
  inject: ["deepClone"],
  components: {
    ContractDetail,
  },
  filters: {
    keyToVal,
    dateFormat,
    dateFormatTemp,
    getProjectType(value, projects) {
      for (const pro of projects) {
        if (pro.Id == value) {
          return pro.Type;
        }
      }
      return "";
    },
    getGuideCode(value, guides) {
      for (const guide of guides) {
        if (guide.Id == value) {
          return guide.IDNumber;
        }
      }
      return "";
    },
    getGuideTel(value, guides) {
      for (const guide of guides) {
        if (guide.Id == value) {
          return guide.Tel;
        }
      }
      return "";
    },
    getDriverTel(value, drivers) {
      for (const driver of drivers) {
        if (driver.Id == value) {
          return driver.Tel;
        }
      }
      return "";
    },
  },
  computed: {
    ...mapState("trip", {
      options: (state) => {
        return {
          projects: state.projects,
        };
      },
    }),
    ...mapState("user", ["storeInfo"]),
    ...mapState("common", ["ticketStatus", "statusType"]),
  },
  methods: {
    //添加订单
    sureAddOrder(){
       var _self=this;
       if(_self.ordersDetail!=null && _self.ordersDetail.length>0){
          _self.ordersDetail.forEach((v) => {
            if (v.isSelected) {
              _self.orderSelected.push(v.Id);
            }
          });

          if(_self.orderSelected!=null && _self.orderSelected.length>0){
            var param={
              Id:_self.detail.Id,
              orderSelected:_self.orderSelected
            };
            Trip.saveNewOrder(param).then((res)=>{
              if(res.status=="success"){
                _self.$message.success(res.msg);
                _self.orderDialog=false;
                _self.getTickets();
                _self.flag=0;
              }
              else{
                  _self.$message.error(res.msg);
              }
            });
          }
          else{
            _self.$message.error('请勾选订单!');
          }
       }
    },
    //判断是否有订单添加
    AddOrderLater(){
      var _self=this;
      var saveParam={
        Id: _self.saveLineId,
        StartTime:_self.saveStartTime,
        EndTime: _self.saveEndTime,
      };
      //获取订单，以供选择
      Trip.selectOrder(saveParam).then((res) => {
        if (res.status === 'success') {
          if (res.content === null || res.content.length === 0) {
            _self.orderSelected = [];
            _self.ordersDetail=[];
            _self.$message.error('无订单添加!');
            return false;
          }
          if (_self.ordersDetail.length == 0) {
            _self.ordersDetail = res.content;
          } else {
            _self.ordersDetail = res.content;
            _self.ordersDetail.forEach((item) => {
              _self.orderSelected.forEach((i) => {
                if (i == item.Id) {
                  _self.$set(item, 'isSelected', true);
                }
              });
            });
            _self.ordersDetail.forEach((item) => {
              if (item.isSelected == undefined || item.isSelected == null || item.isSelected == '') {
                _self.$set(item, 'isSelected', false);
              }
            });
          }
          if(_self.ordersDetail!=null && _self.ordersDetail.length>0){
            _self.orderDialog=true;
          }
          else{
            _self.$message.error('无订单添加!');
          }
        } else {
          _self.$message.error('订单获取失败!');
        }
      });
    },
    changeSelfBus(value){
      var _self=this;
      if(value==='0'){
        _self.model.selfBus=[];
        _self.model.selfBus.push({selfDriverName:'',selfPlateNumber:'',selfDriverTel:''});
      }
      else{
        _self.model.drivers=[];
        _self.model.buses=[];
        _self.model.drivers.push({ Id: "" });
        _self.model.buses.push({ Id: "" });
      }
    },
    //添加自备车
    handleSelfBus(index){
      var _self=this;
      if(index==0){
        _self.model.selfBus.push({selfDriverName:'',selfPlateNumber:'',selfDriverTel:''});
      }
      else{
        _self.model.selfBus.pop();
      }
    },
    dataFilter(val){
      var _self=this;
      var param={PlateNumber:val}
      if(val.length>=2){
          Bus.listAllBuses(param).then((res)=>{
          if(res.status=="success"){
            _self.listBuses = res.content.filter((v) => v.Status === 0)
          }
          else{
            _self.$message.error(res.msg);
          }
        });
      }
    },
    GetData(orderId) {
      var _self = this;
      Order.getContractData({ Id: orderId }).then((res) => {
        if (res.status === "success") {
          _self.contractInfo = res.content;
        } else {
          _self.$message.error("合同获取失败!");
        }
      });
    },

    resetForm(formName){
      if (formName === "queryForm") {
        this.query = {
         Code: "",
          StartTime: "",
          EndTime: "",
          PageSize: 10,
          PageIndex: 1,
        };
      }
      this.getTickets();
    },
   
    getProjectName(id) {
      for (const pro of this.options.projects) {
        if (pro.Id == id) {
          return pro.ProjectName;
        }
      }
      return "";
    },
    openContract(orderId) {
      this.orderId = orderId;
      this.contractDialog = true;

      this.GetData(this.orderId);
    },
    //行程单列表
    getTickets() {
      this.query.PageSize = this.pagination.PageSize;
      this.query.PageIndex = this.pagination.PageIndex;
      this.loadintTable=true;
      Trip.listTrips(this.query).then((res) => {
        if (res.status === "success") {
          this.pagination.total = res.content.Total;
          this.tableData = res.content.OnePageData;
        } else {
          this.$message.error("列表获取失败!");
        }
        this.loadintTable=false;
      });
    },
    //行程单详情
    getDetail(row) {
      //清除信息
      this.model={
        guides: [],
        drivers: [],
        buses: [],
        selfBus:[],
      };

      this.ordersDetail=[]; //订单详情
      this.orderSelected= []; //已选择订单
      this.saveLineId="";
      this.saveStartTime="";
      this.saveEndTime="";

      this.detail.Id = row.Id;
      this.setTripInfo(row.Id);
    },
    //设置路线详情
    setTripInfo(Id) {
      var _self=this;
      _self.loadingLook=true;
      Trip.getTripDetail({ Id }).then((res) => {
        if (res.status === "success") {
          if (res.content.trip === null) {
            _self.$message.error("获取详情失败!");
            return false;
          }
          _self.detail = res.content.trip;
          _self.saveStartTime=res.content.trip.StartTime;
          _self.saveEndTime=res.content.trip.EndTime;

          _self.IsTrip=res.content.trip.IsTrip;
          _self.detail.ItinerariesId = res.content.trip.Id;
          if (
            Array.isArray(res.content.router) &&
            res.content.router.length > 0
          ) {
            _self.table = res.content.router.map((v, i) => {
              return {
                id: i,
                arrangement: v.router.map((a) => {
                  return {
                    PointId: a.PointId, //项目Id
                    DayIndex: a.DayIndex,
                    Time: [a.StartTime, a.EndTime],
                    IsSelf: a.IsZiFei,
                    PointType: a.PointType, //项目类型
                    Projects: a.Projects, //项目名称
                    TimeSpan:a.TimeSpan,//显示分钟
                  };
                }),
              };
            });
          }
           
          _self.model.guides = res.content.guide;
          var Guides=[];
          if(res.content.guide!=null && res.content.guide.length>0){
            for(let k=0;k<res.content.guide.length;k++){
              Guides.push({
                Id:res.content.guide[k].Id,
                Name:res.content.guide[k].Name,
                IDNumber:res.content.guide[k].IDNumber,
                IDCard:res.content.guide[k].IDCard,
                Tel:res.content.guide[k].Tel,
                Status:res.content.guide[k].Status,
              });
            }
          }
          //深克隆 这里不需要深克隆  因为每查看一次都会克隆一次 会反复出现这条数据
          // _self.listGuides = [
          //   ..._self.listGuides,
          //   ..._self.deepClone(res.content.guide),
          // ];
          var Buss=[];
          _self.model.buses = res.content.bus;
          if(res.content.bus!=null && res.content.bus.length>0){
            for(let k=0;k<res.content.bus.length;k++){
              Buss.push({
                Id:res.content.bus[k].Id,
                PlateNumber:res.content.bus[k].PlateNumber,
                Status:res.content.bus[k].Status,
              });
            }
          }
          // _self.listBuses = [
          //   ..._self.listBuses,
          //   ..._self.deepClone(res.content.bus),
          // ];

          var Drivers=[];
          _self.model.drivers = res.content.driver;
          if(res.content.driver!=null && res.content.driver.length>0){
            for(let k=0;k<res.content.driver.length;k++){
              Drivers.push({
                Id:res.content.driver[k].Id,
                Name:res.content.driver[k].Name,
                IdNumber:res.content.driver[k].IdNumber,
                Status:res.content.driver[k].Status,
                Tel:res.content.driver[k].Tel,
              });
            }
          }
          // _self.listDrivers = [
          //   ..._self.listDrivers,
          //   ..._self.deepClone(res.content.driver),
          // ];

          if(res.content.selfBus!=null && res.content.selfBus.length>0){
            _self.model.selfBus=res.content.selfBus.map((v)=>{
              return{
                selfDriverName:v.selfDriverName,
                selfPlateNumber:v.selfPlateNumber,
                selfDriverTel:v.selfDriverTel
              }
            });

            _self.model.drivers=[];
            _self.model.buses=[];
            _self.model.drivers.push({ Id: "" });
            _self.model.buses.push({ Id: "" });
          }
          else{
            _self.model.selfBus=[];
            _self.model.selfBus.push({selfDriverName:'',selfPlateNumber:'',selfDriverTel:''});
          }

          _self.visitors = res.content.tourist;
          if(res.content.tourist!=null){
            _self.saveLineId=res.content.tourist[0].LineId;
          }

          var StartTime1=res.content.trip.StartTime1;
          var EndTime1=res.content.trip.EndTime1;
          if(StartTime1!="" && EndTime1!=""){
            _self.LoadAllGuidesTime(StartTime1,EndTime1,Guides);
            _self.LoadAllDriversTime(StartTime1,EndTime1,Drivers);
            _self.LoadAllBusesTime(StartTime1,EndTime1,Buss);
          }
          
          _self.flag = 1;
        } else {
          _self.$message.error("信息获取失败!");
        }
        _self.loadingLook=false;
      });
    },
    //填充结束时间
    dataChange(value) {
      this.routes.forEach((v) => {
        if (v.Id === this.detail.lineId) {
          this.model.EndTime =
            new Date(value).getTime() + v.DayCount * 60 * 60 * 24 * 1000;
          return;
        }
      });
    },
    //子表操作
    switchSubtable(subId) {
      this.currentSubId = subId;
    },
    //行程安排操作
    handleArrangement(type) {
      if (type === "plus") {
        this.table[this.currentSubId].arrangement.push({
          Id: "",
          Time: ["08:00", "12:00"],
          IsSelf: false,
        });
      } else if (type === "minus") {
        if (this.table[this.currentSubId].arrangement.length > 1) {
          this.table[this.currentSubId].arrangement.pop();
        } else {
          this.$message.error("至少录入一条行程!");
        }
      }
    },
    handlePageSize(value) {
      this.pagination.PageSize = value;
    },
    handlePageIndex(value) {
      this.pagination.PageIndex = value;
    },
    
    //提交
    submitForm(formName) {
      var _self=this;
      if(!_self.detail.StartPoint){
        _self.$message.error("请输入行程起点!");
        return false;
      }
      if(!_self.detail.EndPoint){
        _self.$message.error("请输入行程终点!");
        return false;
      }
      // if (
      //   _self.model.guides.length === 0 ||
      //   _self.model.drivers.length === 0 ||
      //   _self.model.buses.length === 0
      // ) {
      //   _self.$message.error("请检查导游、司机及车辆信息!");
      //   return false;
      // }

      if(_self.model.guides.length === 0){ 
         _self.$message.error("请检查导游信息!");
         return false;
      }

      if(_self.detail.IsSelf==='0'){ //不是自备车时
        _self.model.selfBus=[];
        _self.model.selfBus.push({selfDriverName:'',selfPlateNumber:'',selfDriverTel:''});

        if(_self.model.drivers.length === 0){
          _self.$message.error("请检查司机信息!");
          return false;
        }

        if(_self.model.buses.length === 0){
          _self.$message.error("请检查车辆信息!");
          return false;
        }
      }
      else{  //是自备车 时
        _self.model.drivers=[];
        _self.model.buses=[];

        _self.model.drivers.push({ Id: "" });
        _self.model.buses.push({ Id: "" });

        if(_self.model.selfBus.length===0){
          _self.$message.error("请检查司机、车辆信息是否输入完整!");
          return false;
         }
      }

      _self.detail.newListSelf=_self.model.selfBus;

      // this.detail.TouristCount = this.visitors.reduce((total, value) => total + value.TotoalCount, 0);
      _self.detail.CompanyId = _self.storeInfo.Id;
      _self.detail.GuideId = _self.model.guides.map((v) => v.Id);
      _self.detail.DriverId = _self.model.drivers.map((v) => v.Id);
      _self.detail.BusId = _self.model.buses.map((v) => v.Id);
      
      //准备行程
      let arrangement = [];
      _self.table.forEach((v) => {
        let day = { ListNewItinerariesRoute: [] };
        v.arrangement.forEach((a) => {
          day.ListNewItinerariesRoute.push({
            StartTime: a.Time[0],
            EndTime: a.Time[1],
            DayIndex: v.id + 1,
            Projects: _self.getProjectName(a.Id),
            PointId: a.Id,
            IsZiFei: a.IsSelf,
          });
        });
        arrangement.push(day);
      });
      _self.detail.AddNewItinerariesRoute = arrangement;

      Trip.updateTrip(_self.detail).then((res) => {
        if (res.status === "success") {
          _self.$message.success("修改成功!");
          _self.getTickets();
          _self.flag=0;
        } else {
          _self.$message.error(res.msg);
        }
      });

    },
    //修改事件
    edit() {
      var _self=this;
      _self.GuidesOpitons = JSON.parse(JSON.stringify(_self.listGuides));
      _self.DriversOptions = JSON.parse(JSON.stringify(_self.listDrivers));


      setTimeout(function(){
         _self.model.guides.forEach((item) => {
          if (item.Id != '') {
            _self.GuidesOpitons.forEach((t, index) => {
              if (item.Id == t.Id) {
                _self.GuidesOpitons.splice(index, 1);
              }
            })
          }
        })
      },500);

      setTimeout(function(){
        _self.model.drivers.forEach((item) => {
          if (item.Id != '') {
            _self.DriversOptions.forEach((t, index) => {
              if (item.Id == t.Id) {
                _self.DriversOptions.splice(index, 1);
              }
            })
          }
        })
      },500);
     

      _self.flag = 2;
      _self.currentSubId = 0;
    },
    //导游司机添加删除
    handleMultiple(obj, index) {
      if (obj === "guide") {
        if(index==0){
          if (this.model.guides.length == this.listGuides.length) {
            this.$message.error('已无可用导游!');
            return;
          }
           this.model.guides.push({ Id: "" });
        }
        else{
          this.model.guides.pop();
        }
      } else if (obj === "driver") {
        if(index==0){
          if (this.model.drivers.length == this.listDrivers.length) {
            this.$message.error('已无可用司机!');
            return;
          }
          this.model.drivers.push({ Id: "" });
          this.model.buses.push({ Id: "" });
        }
        else{
          this.model.drivers.pop();
          this.model.buses.pop();
        }
      }
    },
    deleteTicket(row) {
      Trip.deleteTicket({ Id: row.Id }).then((res) => {
        if (res.status === "success") {
          this.$message.success("删除成功!");
          this.getTickets();
        } else {
          this.$message.error("删除失败!");
        }
      });
    },
  
    LoadAllGuides(){
      var _self=this;
      Guide.listAllGuides().then((res) => {
        if (res.status === "success") {
          _self.listGuides = res.content.filter((v) => v.Status === 0);
          _self.GuidesOpitons = JSON.parse(JSON.stringify(_self.listGuides));
        } else {
          _self.$message.error("导游获取失败!");
        }
      });
    },
    LoadAllDrivers(){
      var _self=this;
      Driver.listAllDrivers().then((res) => {
        if (res.status === "success") {
          _self.listDrivers = res.content.filter((v) => v.Status === 0);
          _self.DriversOptions = JSON.parse(JSON.stringify(_self.listDrivers));
        } else {
          _self.$message.error("司机获取失败!");
        }
      });
    },
    LoadAllBuses(){
      var _self=this;
      Bus.listAllBus().then((res) => {
        if (res.status === "success") {
          _self.listBuses = res.content.filter((v) => v.Status === 0);
        } else {
          _self.$message.error("车辆获取失败!");
        }
      });
    },

    LoadAllGuidesTime(StartTime,EndTime,Guides){
      var _self=this;
      var param={
        StartTime:StartTime,
        EndTime:EndTime,
      };
      Guide.listGuidesByTime(param).then((res) => {
        if (res.status === "success") {
          _self.listGuides = res.content.filter((v) => v.Status === 0);
          if(Guides!=null && Guides.length>0){
             for(let k=0;k<Guides.length;k++){
               var aa=_self.listGuides.filter((v)=>v.Id==Guides[k].Id);
               if(aa.length==0){
                 _self.listGuides.push({
                    Id:Guides[k].Id,
                    Name:Guides[k].Name,
                    IDNumber:Guides[k].IDNumber,
                    IDCard:Guides[k].IDCard,
                    Tel:Guides[k].Tel,
                    Status:Guides[k].Status,
                });
               }
             }
          }
          _self.GuidesOpitons = JSON.parse(JSON.stringify(_self.listGuides));
        } else {
          _self.$message.error("导游获取失败!");
        }
      });
    },
    LoadAllDriversTime(StartTime,EndTime,Drivers){
      var _self=this;
      var param={
        StartTime:StartTime,
        EndTime:EndTime,
      };
      Driver.listDriversByTime(param).then((res) => {
        if (res.status === "success") {
          _self.listDrivers = res.content.filter((v) => v.Status === 0);
          if(Drivers!=null && Drivers.length>0){
            for(let k=0;k<Drivers.length;k++){
              var aa=_self.listDrivers.filter((v)=>v.Id==Drivers[k].Id);
              if(aa.length==0){
                _self.listDrivers.push({
                  Id:Drivers[k].Id,
                  Name:Drivers[k].Name,
                  IdNumber:Drivers[k].IdNumber,
                  Status:Drivers[k].Status,
                  Tel:Drivers[k].Tel,
                });
              }
            }
          }
          _self.DriversOptions = JSON.parse(JSON.stringify(_self.listDrivers));
        } else {
          _self.$message.error("司机获取失败!");
        }
      });
    },
    LoadAllBusesTime(StartTime,EndTime,Buss){
      var _self=this;
      var param={
        StartTime:StartTime,
        EndTime:EndTime,
      };
      Bus.listBusesByTime(param).then((res) => {
        if (res.status === "success") {
          _self.listBuses = res.content.filter((v) => v.Status === 0);
          if(Buss!=null && Buss.length>0){
            for(let k=0;k<Buss.length;k++){
              var aa=_self.listBuses.filter((v)=>v.Id==Buss[k].Id);
              if(aa.length==0){
                _self.listBuses.push({
                  Id:Buss[k].Id,
                  PlateNumber:Buss[k].PlateNumber,
                  Status:Buss[k].Status,
                });
               }
            }
          }
        } else {
          _self.$message.error("车辆获取失败!");
        }
      });
    },

    LoadAllTrip(){
      var _self=this;
      Trip.getOrderRoutes().then((res) => {
        if (res.status === "success") {
          _self.routes = res.content;
        } else {
          _self.$message.error("线路获取失败!");
        }
      });
    },
  },
  created() {
    this.getTickets();

    // this.LoadAllGuides();
    // this.LoadAllDrivers();
    // this.LoadAllBuses();
    this.LoadAllTrip();
  },
  watch: {
    "pagination.PageSize": function () {
      this.getTickets();
    },
    "pagination.PageIndex": function () {
      this.getTickets();
    },

    'model.guides': {
      deep: true,
      handler: function(newVal, oldVal) {
        let _self = this;
        _self.GuidesOpitons = JSON.parse(JSON.stringify(_self.listGuides));
        newVal.forEach((item) => {
          if (item.Id != '') {
            _self.GuidesOpitons.forEach((t, index) => {
              if (item.Id == t.Id) {
                _self.GuidesOpitons.splice(index, 1);
              }
            })
          }
        })
      },
    },
    'model.drivers': {
      deep: true,
      handler: function(newVal, oldVal) {
        let _self = this
        _self.DriversOptions = JSON.parse(JSON.stringify(_self.listDrivers))
        newVal.forEach((item) => {
          if (item.Id != '') {
            _self.DriversOptions.forEach((t, index) => {
              if (item.Id == t.Id) {
                _self.DriversOptions.splice(index, 1);
              }
            })
          }
        })
      },
    },

  },
   mounted() {
    this.sessionId = getCookie("sessionId");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.type === "today") {
        let today = new Date();
        vm.query.StartTime = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()} 00:00:00`;
        vm.query.EndTime = new Date();
        vm.getTickets();
      }
    });
  },
};
</script>


<style scoped lang="less">
.main-left {
  width: 40%;
  min-width: 620px;
  border-right: 1px solid #ddd;
}
.main-left .left-table {
  height: 753px;
  background: chocolate;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-right {
  flex: 1;
}
.right-table {
  padding: 20px;
}
.input-form {
  position: relative;
  width: 95%;
  min-width: 1310px;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    // width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.input-form /deep/ .el-input__inner,
.input-form /deep/ .el-input-number,
.input-form /deep/ .el-select {
  border: none;
  width: 100%;
}
.input-form /deep/ .el-date-editor .el-range-input,
.input-form /deep/ .el-date-editor .el-range-separator {
  margin: 4px;
}
.addItem /deep/ .el-button {
  width: 100%;
}
.sub-selected {
  background: cornflowerblue;
}
.subtable-tab {
  position: absolute;
  top: 190px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
  // background: red;
}
.subtable-tab .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.emphasis {
  font-weight: bolder;
}
</style>
